import React, { useEffect, useRef, useState } from "react";
import { Alert, Box, Button, Stack, TextField } from "@mui/material";
import axiosInstance from "../axiosInstance";

export default function ShopifyClientCredentials({ tenantId, onSaved, buttonSx, inputSx }) {
  const [clientId, setClientId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [saving, setSaving] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const requestRef = useRef(null);

  useEffect(() => () => requestRef.current?.abort(), []);

  const saveCredentials = async () => {
    if (!tenantId || saving || !clientId.trim() || !clientSecret.trim()) return;
    const controller = new AbortController();
    requestRef.current = controller;
    setSaving(true);
    setFeedback(null);
    try {
      const response = await axiosInstance.post("/integration/shopify/tenant-secret", {
        TenantId: tenantId,
        ClientId: clientId.trim(),
        ClientSecret: clientSecret,
        GenerateShopifyOAuthUrl: false,
      }, { signal: controller.signal });
      if (controller.signal.aborted) return;
      if (response.data.statusCode !== "OK") {
        setFeedback({ severity: "error", message: "Could not save the client and secret. Please try again." });
        return;
      }
      setClientSecret("");
      setFeedback({ severity: "success", message: "Client and secret saved successfully." });
      await onSaved?.();
    } catch {
      if (!controller.signal.aborted) {
        setFeedback({ severity: "error", message: "Could not save the client and secret. Please try again." });
      }
    } finally {
      if (!controller.signal.aborted) setSaving(false);
    }
  };

  return (
    <Stack spacing={2}>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "repeat(2, minmax(0, 1fr))" }, gap: 2, alignItems: "start" }}>
        <TextField fullWidth label="Enter Client ID" value={clientId} onChange={(event) => setClientId(event.target.value)} disabled={saving} autoComplete="off" sx={inputSx} />
        <TextField fullWidth label="Enter Client Secret" type="password" value={clientSecret} onChange={(event) => setClientSecret(event.target.value)} disabled={saving} autoComplete="new-password" sx={inputSx} />
      </Box>
      {feedback && <Alert severity={feedback.severity}>{feedback.message}</Alert>}
      <Button variant="contained" onClick={saveCredentials} disabled={saving || !tenantId || !clientId.trim() || !clientSecret.trim()} sx={{ alignSelf: "flex-end", ...buttonSx }}>
        {saving ? "Saving..." : "Save client and secret"}
      </Button>
    </Stack>
  );
}
